import "core-js/modules/es.array.reverse.js";
var _class, _DiffStratum;
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable, override } from "mobx";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import DiffableTraits from "../Traits/TraitsClasses/DiffableTraits";
import LegendTraits from "../Traits/TraitsClasses/LegendTraits";
import TimeFilterMixin from "./TimeFilterMixin";
export let DiffStratum = (_class = (_DiffStratum = class DiffStratum extends LoadableStratum(DiffableTraits) {
  constructor(catalogItem) {
    super();
    this.catalogItem = catalogItem;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new DiffStratum(model);
  }
  get legends() {
    if (this.catalogItem.isShowingDiff && this.diffLegendUrl) {
      const urlMimeType = new URL(this.diffLegendUrl).searchParams.get("format") || undefined;
      return [createStratumInstance(LegendTraits, {
        url: this.diffLegendUrl,
        urlMimeType
      })];
    }
    return undefined;
  }
  get diffLegendUrl() {
    const diffStyleId = this.catalogItem.diffStyleId;
    const firstDate = this.catalogItem.firstDiffDate;
    const secondDate = this.catalogItem.secondDiffDate;
    if (diffStyleId && firstDate && secondDate) {
      return this.catalogItem.getLegendUrlForStyle(diffStyleId, JulianDate.fromIso8601(firstDate), JulianDate.fromIso8601(secondDate));
    }
    return undefined;
  }
  get disableDateTimeSelector() {
    return this.catalogItem.isShowingDiff;
  }
  get disableExport() {
    // disable export if showing diff
    // currently there is no way to generate export for the difference layer as
    // it requires 2 time parameters which is not supported in standard WCS
    return this.catalogItem.isShowingDiff;
  }
  get disableSplitter() {
    // disable splitter if showing diff
    // currently there is no use splitting the difference layer because
    // most comparable features like style, datetime etc are disabled.
    return this.catalogItem.isShowingDiff;
  }
}, _defineProperty(_DiffStratum, "stratumName", "diffStratum"), _DiffStratum), _applyDecoratedDescriptor(_class.prototype, "legends", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legends"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "diffLegendUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "diffLegendUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableDateTimeSelector", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableDateTimeSelector"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableExport", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableExport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableSplitter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableSplitter"), _class.prototype), _class);
function DiffableMixin(Base) {
  var _class2;
  let DiffableMixin = (_class2 = class DiffableMixin extends TimeFilterMixin(Base) {
    constructor() {
      super(...arguments);
      makeObservable(this);
      const diffStratum = new DiffStratum(this);
      this.strata.set(DiffStratum.stratumName, diffStratum);
    }
    get hasDiffableMixin() {
      return true;
    }
    get canFilterTimeByFeature() {
      // Hides the SatelliteImageryTimeFilterSection for the item if it is
      // currently showing difference image
      return super.canFilterTimeByFeature && !this.isShowingDiff;
    }
  }, _applyDecoratedDescriptor(_class2.prototype, "canFilterTimeByFeature", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "canFilterTimeByFeature"), _class2.prototype), _class2);
  return DiffableMixin;
}
(function (_DiffableMixin) {
  function isMixedInto(model) {
    return model === null || model === void 0 ? void 0 : model.hasDiffableMixin;
  }
  _DiffableMixin.isMixedInto = isMixedInto;
})(DiffableMixin || (DiffableMixin = {}));
export default DiffableMixin;